import React, { FC } from 'react'
import { HomeView } from '@lib/views'
import ForYouView from 'src/views/home/ForYouView'
import FollowingView from 'src/views/home/FollowingView'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@components/ui/tabs'

const HomePage: FC = () => {
  return (
    <div className="">
      <Tabs defaultValue={HomeView.ForYou}>
        <TabsList className="grid w-full grid-cols-2 max-w-md mx-auto">
          <TabsTrigger value={HomeView.Following}>Following</TabsTrigger>
          <TabsTrigger value={HomeView.ForYou}>For You</TabsTrigger>
        </TabsList>
        <TabsContent value={HomeView.Following}>
          <FollowingView />
        </TabsContent>
        <TabsContent value={HomeView.ForYou}>
          <ForYouView />
        </TabsContent>
      </Tabs>
    </div>
  )
}

export default HomePage
